module.exports = __webpack_public_path__ + "img/lh-logo-purple.f035467d.svg";